import { Modal as MaterialModal } from '@material-ui/core'
import styled from '../../../theme'

const ModalFlex = styled(MaterialModal)`
  display: flex;
  align-items: center;
  justify-content: center;
  user-select: none;
`

export default ModalFlex
